export default __webpack_public_path__ + "static/media/os2.8e334b48.png";